import { createSignal } from '@verclam/pulsar';

export type OrganizationSidebarContext = {
	readonly organizationId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the organization carried by `organizationId`; an
 * `organizationId` of `null` inside an open context creates one instead.
 */
const organizationSidebarSignal = createSignal<OrganizationSidebarContext | null>(null);

export const openOrganizationSidebar = (organizationId: number | null): void => {
	organizationSidebarSignal.value = { organizationId };
};

export const closeOrganizationSidebar = (): void => {
	organizationSidebarSignal.value = null;
};

export default organizationSidebarSignal;
